// @ts-nocheck
/**
 * uiDialogsAndTour.ts
 * UI ダイアログ・ツアー・ログイン・利用規約関連メソッド
 * App.vue から切り出し
 */

import { requestAddLayers } from '@/js/layerEngine/addLayersGate'

type VM = any

export function showTermsDialog(vm: VM) {
  const termsHtml = `
<div style="max-height: 60vh; overflow-y: auto; text-align: left; font-size: 13px; line-height: 1.6;">
<h4 style="margin-top: 0;">第1条（サービスの性質）</h4>
<p>本サービス「open-hinata3（以下、本サービス）」は、地図情報・座標情報・ハザード情報・OCR処理結果等を参考情報として提供するものであり、登記、測量、境界確定、契約、申請、法的判断その他の専門的判断を<strong>代替するものではありません</strong>。</p>
<p>本サービスの情報を用いた最終的な判断および確認は、すべて利用者自身の責任において行うものとします。</p>

<h4>第2条（SIMA・座標・面積等の免責）</h4>
<p>本サービスが出力するSIMAファイル、座標値、面積値、幾何計算結果は、正確性・完全性・特定目的適合性を保証するものではありません。</p>
<p>これらの出力結果を登記、測量成果、境界確定、契約、申請等に利用する場合に生じたいかなる損害についても、運営者は一切の責任を負いません。</p>
<p>利用者は、必ず自己の専門的確認・現地確認・再計算・第三者確認等を行った上で利用するものとします。</p>

<h4>第3条（OCR機能に関する免責）</h4>
<p>OCR機能は画像・PDF等からの文字認識を補助するものであり、誤認識・欠落・読み違いが必ず発生し得ることを利用者は了承するものとします。</p>
<p>OCR結果をもとに作成されたデータ、SIMA、成果物等についても、最終確認責任はすべて利用者に帰属します。</p>

<h4>第3条の2（AI・自動生成・外部APIに関する免責）</h4>
<p>本サービスには、AIによる自動解析・自動生成・推定処理（以下、AI機能）が含まれる場合があります。</p>
<p>AI機能が出力する情報、解析結果、推定結果、文章、数値、分類結果等は、必ずしも正確、完全、最新であることを保証するものではありません。</p>
<p>AI機能の出力結果は、あくまで参考情報として提供されるものであり、これを登記、測量、境界確定、契約、申請、法的判断、業務判断その他一切の判断に直接利用したことによって生じる損害について、運営者は一切の責任を負いません。</p>
<p>AI機能の利用にあたっては、必ず利用者自身の確認、再計算、第三者確認等を行うものとします。</p>

<h4>第4条（非保証）</h4>
<p>本サービスについて、以下の事項について一切保証しません。</p>
<ul style="margin: 8px 0; padding-left: var(--oh3-spacing-5);">
<li>中断しないこと</li>
<li>エラーが発生しないこと</li>
<li>データが消失しないこと</li>
<li>外部データ（地図・公図・ハザード・API等）の継続提供</li>
<li>特定の成果を得られること</li>
</ul>

<h4>第5条（損害賠償の上限）</h4>
<p>本サービスの利用に関連して利用者に損害が生じた場合であっても、運営者の責任は、故意または重過失がある場合を除き、一切負わないものとします。</p>

<h4>第6条（業務利用・商用利用）</h4>
<p>本サービスを業務、商用、報酬を伴う活動に利用する場合であっても、本規約に定める免責および責任制限がすべて適用されるものとします。</p>

<h4>第7条（サービスの停止・終了）</h4>
<p>運営者は、事前の通知なく本サービスの全部または一部を停止、変更、終了できるものとします。これにより利用者に損害が生じても、運営者は一切責任を負いません。</p>

<h4>第8条（規約の変更）</h4>
<p>本規約は、利用者の承諾なく変更できるものとし、変更後に本サービスを利用した場合、変更後の規約に同意したものとみなします。</p>
</div>
  `
  vm.$store.dispatch('messageDialog/open', {
    id: 'terms-of-service',
    title: '利用規約',
    contentHtml: termsHtml,
    options: { icon: 'mdi-file-document-outline', iconColor: 'primary' }
  })
}

export function getMapTitle(vm: VM, mapName) {
  return vm.$store.state.printTitleTexts[mapName] || ''
}

export function formatPrintDate(vm: VM, dateStr) {
  if (!dateStr) return ''
  try {
    const date = new Date(dateStr + 'T00:00:00')
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}年${month}月${day}日`
  } catch (e) {
    return dateStr
  }
}

export function getSourceData(vm: VM, source) {
  if (!source || !source._data) return null
  const rawData = source._data
  return (rawData && rawData.geojson) ? rawData.geojson : rawData
}

export function openLoginDialog(vm: VM) {
  vm.$store.state.initialLoginMode = 'login'
  vm.s_dialogForLogin = true
}

export function openSignUpDialog(vm: VM) {
  vm.$store.state.initialLoginMode = 'signup'
  vm.s_dialogForLogin = true
}

export function openHillshadeDialog(vm: VM) {
  vm.$refs.hsPanel?.openDialog()
}

export function closeSignUpPromo(vm: VM) {
  vm.showSignUpPromoDialog = false
  if (vm.dontShowSignUpPromo) {
    localStorage.setItem('oh3.hideSignUpPromo', '1')
  }
}

export function startSignUp(vm: VM) {
  vm.showSignUpPromoDialog = false
  openSignUpDialog(vm)
}

export function startLogin(vm: VM) {
  vm.showSignUpPromoDialog = false
  openLoginDialog(vm)
}

export function startTour(vm: VM, tourType = 'basic') {
  vm.showSignUpPromoDialog = false
  vm.currentTourType = tourType
  setTimeout(() => {
    vm.usageTourStep = 0
    vm.showUsageTour = true
    const firstStep = vm.currentTourSteps[0]
    if (firstStep && firstStep.onEnter) {
      setTimeout(() => firstStep.onEnter(), 100)
    }
  }, 300)
}

export function handleUsageTourNext(vm: VM) {
  // 透過度アニメーションを停止
  if (vm.opacityAnimationTimer) {
    clearTimeout(vm.opacityAnimationTimer)
    vm.opacityAnimationTimer = null
    const layers = vm.$store.state.selectedLayers.map01
    const layer = layers?.find(l => l.id === 'oh-seamlessphoto')
    const map = vm.$store.state.map01
    if (layer) {
      layer.opacity = 1
      if (map && layer.layers) {
        layer.layers.forEach(layerDef => {
          if (layerDef.type === 'raster') {
            map.setPaintProperty(layerDef.id, 'raster-opacity', 1)
          }
        })
      }
      requestAddLayers(vm.$store, 'map01')
    }
  }
  if (vm.layerSwapTimer) {
    clearTimeout(vm.layerSwapTimer)
    vm.layerSwapTimer = null
  }

  if (vm.usageTourStep < vm.currentTourSteps.length - 1) {
    const nextStepIndex = vm.usageTourStep + 1
    const nextStep = vm.currentTourSteps[nextStepIndex]

    if (nextStep && nextStep.delayShow) {
      vm.showUsageTour = false
      if (nextStep.onEnter) {
        nextStep.onEnter()
      }
      setTimeout(() => {
        vm.usageTourStep = nextStepIndex
        vm.showUsageTour = true
      }, nextStep.delayShow)
    } else {
      vm.usageTourStep = nextStepIndex
      if (nextStep && nextStep.onEnter) {
        setTimeout(() => nextStep.onEnter(), 100)
      }
    }
  }
}

export function handleUsageTourSkip(vm: VM) {
  if (vm.opacityAnimationTimer) {
    clearTimeout(vm.opacityAnimationTimer)
    vm.opacityAnimationTimer = null
  }
  if (vm.layerSwapTimer) {
    clearTimeout(vm.layerSwapTimer)
    vm.layerSwapTimer = null
  }
  vm.$store.dispatch('hideFloatingWindow', 'layer-window-map01')
  vm.showUsageTour = false
  vm.usageTourStep = 0
}

export function handleUsageTourComplete(vm: VM) {
  if (vm.opacityAnimationTimer) {
    clearTimeout(vm.opacityAnimationTimer)
    vm.opacityAnimationTimer = null
    const layers = vm.$store.state.selectedLayers.map01
    const layer = layers?.find(l => l.id === 'oh-seamlessphoto')
    const map = vm.$store.state.map01
    if (layer) {
      layer.opacity = 1
      if (map && layer.layers) {
        layer.layers.forEach(layerDef => {
          if (layerDef.type === 'raster') {
            map.setPaintProperty(layerDef.id, 'raster-opacity', 1)
          }
        })
      }
      requestAddLayers(vm.$store, 'map01')
    }
  }
  if (vm.layerSwapTimer) {
    clearTimeout(vm.layerSwapTimer)
    vm.layerSwapTimer = null
  }
  vm.showUsageTour = false
  vm.usageTourStep = 0
}

export function onConfirmOk(vm: VM) {
  const s = vm.$store.state
  const r = s.confirmResolve
  s.confirmResolve = null
  r && r(true)
}

export function onConfirmCancel(vm: VM) {
  const s = vm.$store.state
  const r = s.confirmResolve
  s.confirmResolve = null
  r && r(false)
}

export function onConfirmMiddle(vm: VM) {
  const s = vm.$store.state
  const r = s.confirmResolve
  s.confirmResolve = null
  r && r('middle')
}

export function fullscreenForIframe(vm: VM) {
  const win = window.open('', '_blank')
  vm.$store.state.isFromIframe = true
  vm.updatePermalink()

  setTimeout(() => {
    const oh3Url = vm.$store?.state?.url || location.href
    if (win && !win.closed) {
      try {
        win.location.href = oh3Url
        return
      } catch (_) {}
    }

    try {
      const a = document.createElement('a')
      a.href = oh3Url
      a.target = '_top'
      a.rel = 'noopener noreferrer'
      document.body.appendChild(a)
      a.click()
      a.remove()
    } catch (_) {
      try { window.top.location.href = oh3Url } catch (_) {}
    }
  }, 60)
}

export function waitForMap(vm: VM, mapKey = 'map01', { loaded = true, interval = 50, timeout = 10000 } = {}) {
  return new Promise((resolve, reject) => {
    const t0 = Date.now()
    const iv = setInterval(() => {
      const map = vm.$store.state[mapKey]
      if (map) {
        if (!loaded || map.loaded?.()) {
          clearInterval(iv); resolve(map)
        } else {
          map.once('idle', () => { clearInterval(iv); resolve(map) })
        }
      } else if (Date.now() - t0 > timeout) {
        clearInterval(iv); reject(new Error(`waitForMap('${mapKey}') timeout`))
      }
    }, interval)
  })
}
